import React from 'react';
import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import ProposalInsightContainer
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/ProposalInsightPicker/ProposalInsightContainer';

const ProposalInsightPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.proposalPreviewDataForScenarioSelectionRedefined.name]: <ProposalInsightContainer />,
  }, () => null);
};

ProposalInsightPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ProposalInsightPicker;
